export enum SupervisorSpyAction {
  spy = 'spy',
  barge = 'barge',
  whisper = 'whisper',
  hangup = 'hangup',
  forceHangup = 'forceHangup'
}
